import { NgModule } from '@angular/core';

import { SharedModule } from '@shared';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home/home.component';
import { HomeRedirectorGuard } from './redirector/home-redirector.guard';

@NgModule({
  imports: [
    HomeRoutingModule,
    SharedModule
  ],
  declarations: [
    HomeComponent
  ],
  providers: [
    HomeRedirectorGuard
  ]
})
export class HomeModule { }
